import { Component, Element, Host, h } from '@stencil/core';
import { attachSlottedCss, injectCSS, injectFont } from '../../utils';
import { createStyles } from './table-styles';
import { getSlottedCss } from './table-styles';

@Component({
  tag: 'dc-ui-table',
  shadow: true,
})
export class DcUiTable {
  @Element() el: HTMLElement;

  componentWillLoad() {
    injectFont();
  }

  public connectedCallback(): void {
    attachSlottedCss(this.el, getSlottedCss(this.el));
  }

  render() {
    injectCSS(this.el, createStyles);

    return (
      <Host>
        <div class="table-container">
          <slot></slot>
        </div>
      </Host>
    );
  }
}
